<div class="card mb-4" id="noticias-container" *ngIf="showVideo && permissions.getPermission('83').asignado">
	<div class="card-header">
		<div class="d-flex align-items-center mb-0">
			<div class="symbol symbol-40 symbol-dark-primary mr-5 d-none d-md-block">
				<span class="symbol-label">
					<span [inlineSVG]="'./assets/media/svg/icons/Home/Bulb1.svg'" cacheSVG="true" class="svg-icon svg-icon-xl svg-icon-primary"></span>
				</span>
			</div>
			<div class="d-flex flex-column font-weight-bold">
				<h4 class="text-dark text-hover-primary mb-1 font-size-xl">¡Payku llegó a SimpleFactura!</h4>
				<span class="text-muted"> Convierte tus DTEs en pagos inmediatos </span>
			</div>
		</div>
	</div>
	<div class="card-content">
		<div class="card-body">
			<div class="mb-5">
				<div class="d-flex justify-content-center">
					<div class="video-wrap">
						<iframe src="https://www.youtube-nocookie.com/embed/VtT-SiyxAX0?autoplay=1&mute=1&rel=0&showinfo=0&controls=1&modestbranding=1&iv_load_policy=3&fs=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen> </iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card mb-4" id="noticias-container">
	<div class="card-header">
		<div class="d-flex align-items-center mb-0">
			<div class="symbol symbol-40 symbol-dark-primary mr-5 d-none d-md-block">
				<span class="symbol-label">
					<span [inlineSVG]="'./assets/media/svg/icons/Home/Book.svg'" cacheSVG="true" class="svg-icon svg-icon-xl svg-icon-primary"></span>
				</span>
			</div>
			<div class="d-flex flex-column font-weight-bold">
				<h4 class="text-dark text-hover-primary mb-1 font-size-xl">Noticias de Interés</h4>
				<span class="text-muted">Del SII y TGR</span>
			</div>
		</div>
		<!-- <h4 class="card-title mb-0">
            Resumen Folios
        </h4> -->
	</div>
	<div class="card-content">
		<div class="card-body">
			<ng-container *ngIf="listNoticias">
				<div *ngFor="let noticia of listNoticias" class="mb-5">
					<div class="d-flex">
						<!--begin::Pic-->
						<div class="flex-shrink-0 mr-7">
							<div class="symbol symbol-50">
								<img alt="Pic" src="{{ noticia.imagen }}" class="d-none d-lg-inline-block" style="width: 100%; height: 140px; min-width: 200px" />
								<!-- Imagen para sm y tamaños menores -->
								<img alt="Pic" src="{{ noticia.imagen }}" class="d-lg-none" style="width: 100%; height: 80px; min-width: 100px" />
							</div>
						</div>
						<!--end::Pic-->
						<!--begin: Info-->
						<div class="flex-grow-1">
							<!--begin::Title-->
							<div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
								<!--begin::User-->
								<div class="mr-3">
									<!--begin::Name-->
									<a href="{{ noticia.link }}" target="_blank" rel="noopener noreferrer" class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3">{{ noticia.titulo }} <i class="flaticon2-correct text-success icon-md ml-2"></i></a>
									<!--end::Name-->
									<!--begin::Contacts-->
									<div class="d-flex flex-wrap my-2">
										<a href="#" class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
											<i class="fa-sharp fa-regular fa-calendar-days"></i>
											{{ noticia.fecha | date : "dd/MM/yyyy" }}</a
										>
										<a href="#" class="text-muted text-hover-primary font-weight-bold"> <i class="fa-sharp fa-regular fa-share-from-square"></i> {{ noticia.origen }}</a>
									</div>
									<!--end::Contacts-->
								</div>
								<!--begin::User-->
								<!--begin::Actions-->
								<!-- <div class="my-lg-0 my-1">
                                    <a href="#" class="btn btn-sm btn-primary font-weight-bolder text-uppercase">IR</a>
                                </div> -->
								<!--end::Actions-->
							</div>
							<!--end::Title-->
							<!--begin::Content-->
							<!-- <div class="d-flex align-items-center flex-wrap justify-content-between">
                                <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">{{noticia.titulo}}</div>
                            </div> -->
							<!--end::Content-->
						</div>
						<!--end::Info-->
					</div>
					<!-- <div class="row form-group mx-auto mb-10">
                        <div class="col-8">
                            <h4 class="font-weight-bold">{{noticia.titulo}}</h4>
                        </div>
                    </div> -->
				</div>
			</ng-container>
			<ng-container *ngIf="isLoading">
				<div class="row">
					<div class="offset-5 col-1">
						<span class="spinner spinner-primary spinner-lg ml-5"></span>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
